import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const MileageComponent = React.lazy(() => import("../Components/RootComponents/MileageComponent"));
const MileagePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <MileageComponent />
      </Suspense>
    </Fragment>
  );
};

export default MileagePage;
